import { AxiosInstance } from '../../utilities/requestClient';
import { getFundsRoute } from '../../routes/endpoints/general.routes';
import { FundData, GetFundsParams } from './types';

/**
 * Get funds data
 * @param params - Query parameters including fundTypes, rsResources, and raptorPlatformId
 * @returns Promise<FundData[]>
 */
export const getFunds = async (params: GetFundsParams): Promise<FundData[]> => {
  const { fundTypes, rsResources, raptorPlatformId } = params;

  const route = getFundsRoute(fundTypes, rsResources, raptorPlatformId);

  return (await AxiosInstance.get<FundData[]>(`/${route}`)).data;
};
